import React, { Component } from 'react';
import Typography from '@mui/material/Typography';
import background from '@public/errorPage.svg';
import { datadogRum } from '@datadog/browser-rum';
import Grid from '@mui/material/Grid';

import withRouter from '../hoc/withRouter';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (['stage', 'production'].includes(process.env.NODE_ENV)) {
      if (error?.name !== 'ChunkLoadError') {
        datadogRum.addError(error, {
          errorInfo,
        });
      }
      if (this.props.location.pathname !== '/') {
        setTimeout(() => {
          if (
            this.props.navigate &&
            this.props.location.pathname !== '/conversations'
          ) {
            this.props.navigate('/');
          }
          setTimeout(() => window.location.reload(true), 1000);
        }, 1000);
      }
    }
  }

  render() {
    if (this.state.hasError &&
      ['stage', 'production'].includes(process.env.NODE_ENV)) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundImage: `url(${background})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <Grid container justifyContent="center" spacing={3}>
            <Grid item xs={10} align="center">
              <Typography
                variant="h2"
                color="inherit"
                children={'Une erreur s\'est produite !'}
              />
              <Typography
                variant="h5"
                color="inherit"
                children={'Actualisation en cours ...'}
              />
            </Grid>
          </Grid>
        </div>
      );
    }
    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
